import React from 'react'

export default function Modal({ offer, setOpenDetails }) {
    return (

        <div className="section__modal wf-section">
            <div className="modal__container"  onClick={(e) => {if (e.target.className === 'modal__container') {setOpenDetails(false)}}}>
                <div className="modal__content">
                    <a onClick={() => setOpenDetails(false)} className="modal__close w-inline-block">
                        <img src="/assets/images/close.png" loading="lazy" alt="" className="image-35" />
                    </a>
                    <div className="modal_container">
                        <div className="modal_course-title">{offer.course_name || offer.exam_name}</div>
                        {(offer.course_description?.trim() || offer.exam_description?.trim()) && (
                            <div
                                className="modal_course-text"
                                dangerouslySetInnerHTML={{
                                __html: (offer.course_description || offer.exam_description)
                                    .replace(/\\r\\n/g, '<br />')
                                    .replace(/\r?\n|\r/g, '<br />')
                                }}
                            />
                        )}
                     
                        <div className="modal_course-block">
                            <div className="modal_course-subtitle">Conteúdo</div>
                            {offer.course_content?.trim() && (
                        <div
                            className="modal_course-text modal__conteudo"
                            dangerouslySetInnerHTML={{
                            __html: offer.course_content
                                .replace(/\\r\\n/g, '<br />')
                                .replace(/\r?\n|\r/g, '<br />')
                            }}
                        />
                        )}
                        </div>
                        <div className="modal_course-block course-block-items">
                            <div className="modal_course-block-item">
                                <img src="/assets/images/modalidade.png" loading="lazy" alt="" className="course-block-icon" />
                                <div className="modal_course-subtitle">Modalidade</div>
                                <div className="modal_course-text">{offer.course_modality || offer.exam_modality}</div>
                                {
                                    (offer.course_modality=== "Presencial" || offer.exam_modality === "Presencial") &&
                                    <div className="modal_course-text">
                                        {offer.address} - {offer.neighborhood} <br/>
                                        {offer.city} - {offer.uf}
                                    </div>
                                }
                            </div>
                            <div className="modal_course-block-item">
                                <img src="/assets/images/calendar-icon_1.png" loading="lazy" alt="" className="course-block-icon" />
                                {offer?.exam_final_register_date ? (
                                    <>
                                        <div className="modal_course-subtitle">Prazo para inscrições </div>
                                        <div className="modal_course-text">até {offer.exam_final_register_date}</div>
                                    </>
                                ) : (
                                    <>
                                        <div className="modal_course-subtitle">Período</div>
                                        <div className="modal_course-text">{offer.course_period}</div>
                                    </>
                                )}
                            </div>
                            <div className="modal_course-block-item">
                                <img src="/assets/images/duration.png" loading="lazy" alt="" className="course-block-icon" />
                                {offer?.exam_test_date ? (
                                    <>
                                        <div className="modal_course-subtitle">Data e hora da prova</div>
                                        <div className="modal_course-text">{offer.exam_test_date}</div>
                                    </>
                                ) : (
                                    <>
                                        <div className="modal_course-subtitle">Duração</div>
                                        {offer.course_duration?.trim() && (
                                            <div
                                                className="modal_course-text"
                                                dangerouslySetInnerHTML={{
                                                __html: offer.course_duration.replace(/\r?\n/g, '<br />')
                                                }}
                                            />
                                            )}
                                    </>
                                )}
                            </div>
                        </div>
                        <div className="modal_course-block">
                            
                            {offer.course_information?.trim() && (
                                    <>
                                        <div className="modal_course-subtitle">Informação</div>
                                        <div
                                            className="modal_course-text"
                                            dangerouslySetInnerHTML={{
                                            __html: offer.course_information.replace(/\r?\n/g, '<br />')
                                            }}
                                        />
                                    </>
                                )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
